// @ts-ignore
import { fetch } from 'whatwg-fetch';
import Auth from '../services/auth';

type Headers = {
  [key: string]: string;
};

interface FetchOptions {
  method: string;
  credentials: string;
  headers: any;
  body?: any;
  signal?: any;
}

export interface HttpClientOptions {
  timeout: number;
  abortController?: AbortController;
}

const defaultHttpClientOptions: HttpClientOptions = {
  timeout: Number(process.env.REACT_APP_DEFAULT_HTTP_TIMOUT),
};

// eslint-disable-next-line func-names
export default async function (
  url: string,
  method: string,
  data?: any,
  headers?: Headers,
  userOptions: HttpClientOptions = defaultHttpClientOptions,
): Promise<any> {
  const options = { ...defaultHttpClientOptions, ...userOptions };
  const fetchOptions: FetchOptions = {
    method,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      token: Auth().getAccessToken(),
      ...headers,
    },
  };

  if (method !== 'GET') {
    fetchOptions.body = JSON.stringify(data);
  }

  let controller: AbortController;
  let timeoutId: any;
  if (window.AbortController) {
    controller = options.abortController || new AbortController();
    fetchOptions.signal = controller.signal;
    timeoutId = setTimeout(() => {
      controller.abort();
      console.warn('Request timeout', `${method}: ${url}`);
    }, 35000);
  }
  const fetchResults = await fetch(url, fetchOptions);
  clearTimeout(timeoutId);

  return fetchResults;
}
